import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'

const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api',
  timeout: 30000
})

request.interceptors.request.use(
  config => {
    // 只使用 localStorage 获取 token，避免 Cookie 问题
    const token = localStorage.getItem('token') || ''
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => Promise.reject(error)
)

request.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      Message({ message: res.message || '请求失败', type: 'error', duration: 5 * 1000 })
      if (res.code === 401) {
        MessageBox.confirm('您的登录已过期，请重新登录', '提示', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      }
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res.data
  },
  error => {
    // 认证失效：清理本地登录态，引导重新登录
    if (error.response && error.response.status === 401) {
      Message({ message: '登录已过期，请重新登录', type: 'warning', duration: 3 * 1000 })
      localStorage.removeItem('token')
      store.dispatch('user/resetToken').then(() => {
        if (location.pathname !== '/login') location.href = '/login'
      })
      return Promise.reject(error)
    }
    // 超时类错误单独提示：请求虽超时，后端可能仍在处理（如学习任务），稍后刷新看结果即可
    if (error.code === 'ECONNABORTED' || /timeout/i.test(error.message || '')) {
      Message({ message: '请求超时：服务仍在后台处理，稍后刷新查看结果即可', type: 'warning', duration: 5 * 1000 })
      return Promise.reject(error)
    }
    Message({ message: error.message || '请求失败', type: 'error', duration: 5 * 1000 })
    return Promise.reject(error)
  }
)

export default request

